import { Field, Input, Textarea } from "@fluentui/react-components";
import { ChangeEvent } from "react";
import { ConstantValues } from "common/constants";
import { LabelWithInfo } from "../../labelWithInfo/LabelWithInfo";
import { IAiGeneratedQuestionsFormProps } from "./editObjective.types";

export const AiGeneratedQuestionsForm = (
  props: IAiGeneratedQuestionsFormProps,
): JSX.Element => {
  const handleDescriptionChange = (
    _: ChangeEvent<HTMLTextAreaElement>,
    data: { value: string },
  ): void => {
    props.onDescriptionChange(data.value);
  };

  const handleMaxQuestionsChange = (
    _: ChangeEvent<HTMLInputElement>,
    data: { value: string },
  ): void => {
    const v = data.value?.trim();
    props.onMaxQuestionsChange(
      v === ConstantValues.EMPTY_STRING ? undefined : Number(v),
    );
  };

  return (
    <>
      <Field
        label={
          <LabelWithInfo
            label="Description/Goal"
            info="Provide a thorough goal description that will be used by the AI to generate questions"
            required
          />
        }
        validationState={props.fieldErrors.description ? "error" : "none"}
        validationMessage={props.fieldErrors.description}
      >
        <div className={props.editStyles.generateObjectiveLink} onClick={() => props.setActiveTab("generate")}>
           Generate Description/Goal using AI
        </div>
        <Textarea
          ref={props.descriptionRef}
          value={props.description}
          rows={7}
          disabled={props.isLoading}
          onChange={handleDescriptionChange}
          placeholder="Describe the objective goal..."
        />
      </Field>

      <Field
        label={
          <LabelWithInfo
            label="Number of questions"
            info=" Set the number of questions to be asked for this objective"
            required
          />
        }
        validationState={props.fieldErrors.maxQuestions ? "error" : "none"}
        validationMessage={props.fieldErrors.maxQuestions}
      >
        <Input
          ref={props.maxQuestionsRef}
          type="number"
          value={
            props.maxQuestions?.toString() ?? ConstantValues.EMPTY_STRING
          }
          min={0}
          step={1}
          disabled={props.isLoading}
          placeholder="Enter number of questions..."
          onChange={handleMaxQuestionsChange}
        />
      </Field>

      <Field
        label={
          <LabelWithInfo
            label="Starter Question"
            info="Set a starter question for the AI to ask"
            required
          />
        }
        validationState={props.fieldErrors.starterQuestion ? "error" : "none"}
        validationMessage={props.fieldErrors.starterQuestion}
      >
        <Input
          ref={props.starterQuestionRef}
          value={props.starterQuestion}
          placeholder="Enter a starter question..."
          disabled={props.isLoading}
          onChange={(_, data) => props.onStarterQuestionChange(data.value)}
        />
      </Field>
    </>
  );
};
